// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import moment from 'moment'
Vue.prototype.$moment = moment

import { HappyScroll } from 'vue-happy-scroll'
// 引入css，推荐将css放入main入口中引入一次即可。
import 'vue-happy-scroll/docs/happy-scroll.css'
// //全局注册
// import scroll from 'vue-seamless-scroll'
// Vue.use(scroll)

// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI)

import 'element-ui/lib/theme-chalk/index.css';
import {
  DatePicker,
  TimePicker,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Select,
  Option, OptionGroup,
  Pagination,
  Row,
  Col,
  Icon,
  Tabs,
  TabPane,
  Popover,
  Tooltip,
  Carousel,
  CarouselItem,
  Image,
  Message,
  Button,
  Input,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Dialog,
  InputNumber,
  Steps,
  Step,
  Upload,
  Calendar,
  Autocomplete
} from "element-ui";
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Pagination);
Vue.use(Row);
Vue.use(Col);
Vue.use(Icon);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Image);
Vue.use(Input);
Vue.prototype.$message = Message;
Vue.prototype.$Dialog = Dialog;
Vue.use(Button);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Dialog);
Vue.use(TimePicker);
Vue.use(DatePicker);
Vue.use(InputNumber);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Upload);
Vue.use(Calendar);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Autocomplete);


import '@/common/flexible.js';

import * as echarts from 'echarts';

import geoJson from '@/utils/china.json'
echarts.registerMap('china', geoJson);

import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';
Vue.use(vuescroll);
Vue.config.productionTip = false


//引入vant
// import Vant from 'vant'
// import 'vant/lib/index.css'
// Vue.use(Vant)
import 'vant/lib/index.css'
import { Button as VButton, Swipe, SwipeItem, Grid, GridItem, Icon as VIcon, Collapse, CollapseItem, Sticky, Popup, } from "vant";
Vue.use(VButton);
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(VIcon);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Sticky);
Vue.use(Popup);
// // 按需全局引入 vant组件
// import Vue from 'vue'
// import {List, Cell, Tabbar, TabbarItem,Overlay
//   Lazyload } from 'vant'
// import 'vant/lib/index.css';

// Vue.use(Cell)
// Vue.use(List)

// Vue.use(Overlay)

// Vue.use(Lazyload)
// Vue.use(Tabbar).use(TabbarItem)





//引入swiper
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(vueSwiper)



import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

// import vueMiniPlayer from 'vue-mini-player'
// import 'vue-mini-player/lib/vue-mini-player.css'
// Vue.use(vueMiniPlayer)

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);

import Api from './utils/request1.js';

Vue.prototype.$api = Api

router.beforeEach((to, from, next) => {
  next()
})

new Vue({
  el: '#app',
  // i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js